import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Link } from "react-router-dom";

class CustomDropZone extends React.Component {
  render() {
    let {
      fileList,
      updateFileList,
      removeFile,
      heading,
      uploadMsg,
      flag,
      downloadFileName,
    } = this.props;
    let listToShow = [];

    for (let fileName in fileList) {
      listToShow.push(
        <li
          className="list-group-item d-flex justify-content-between"
          key={fileName}
        >
          <span>{fileName}</span>
          {fileList[fileName] !== "#empty" && uploadMsg !== "files uploaded" && (
            <span
              className="fw-bold"
              onClick={() => removeFile(fileName, flag)}
            >
              {"X"}
            </span>
          )}
        </li>
      );
    }

    return (
      <div className="customDropZone">
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="m-0">{heading}</h6>
          <Link
            to={"/" + downloadFileName}
            target="_blank"
            className="d-flex align-items-center"
            download
          >
            <span>Download reference file</span>
            <div style={{ fontWeight: "900", fontSize: "24px" }}>⬇</div>
          </Link>
        </div>
        <DropZone updateFileList={updateFileList} flag={flag} />
        {<ul className="list-group list-group-flush">{listToShow}</ul>}
      </div>
    );
  }
}

const DropZone = (props) => {
  let { updateFileList } = props;
  const [errorMsg, setErrorMsg] = useState("");
  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    setErrorMsg("");
    if (fileRejections.length > 0) {
      setErrorMsg("Please select a CSV File.");
    } else {
      acceptedFiles.forEach((file) => {
        updateFileList(file, props.flag);
      });
    }
  });
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: ".csv",
    multiple: false,
  });

  return (
    <>
      <div {...getRootProps({ className: `dropzone` })}>
        <input {...getInputProps()} />
        <span>{"📂"}</span>
        <div className="dropZoneText">
          Drag &amp; drop files or Browse
        </div>
        {(
          <div>
            <p className="font-family-montserrat" style={{ fontSize: "12px", color: "grey", marginBottom: "0px", fontWeight: "600" }}>
              Supported Formats : Excel(.xlsx, .xls) , Max File Size : 10MB
            </p>
            <p>
              <p className="font-family-montserrat" style={{ fontSize: "12px", color: "grey", marginBottom: "0px", fontWeight: "600" }}>
                Upload one or more Payroll file at once
              </p>
            </p>
          </div>
        )}
      </div>

      {errorMsg && (
        <p style={{ color: "red", marginTop: "0.5rem" }}>{errorMsg}</p>
      )}
    </>
  );
};

export default CustomDropZone;
